import Crud from '../components/Roles/Crud'
import Add from '../components/Roles/Add'

let routes = {
    path: '/roles',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/roles',
            name: 'Cargos',
            component: Crud
        },
        {
            path: '/role/:id?',
            name: 'Cargos',
            component: Add
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/roles.js